module.exports = __webpack_public_path__ + "img/rectangle_opaque.c2f7c33a.svg";